import http from 'utils/http';
import { getContactUrl, getNotesUrl, getNoteUrl } from './apiUrls';
import { ContactRequest, ContactResponse, NoteRequest, NotesResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getContact(workspaceId: string, id: number, params?: Object): Promise<ContactResponse> {
  return http.get(getContactUrl(workspaceId, id), params);
}

export function updateContact(
  workspaceId: string,
  id: number,
  payload: ContactRequest
): Promise<{ meta: { message: string } }> {
  return http.put(getContactUrl(workspaceId, id), payload);
}

export function getNotes(
  workspaceId: string,
  id: number,
  params?: Object
): Promise<{ data: NotesResponse[]; meta: MetaApiResponse }> {
  return http.get(getNotesUrl(workspaceId, id), params);
}

export function createNote(workspaceId: string, id: number, payload?: NoteRequest): Promise<NotesResponse> {
  return http.post(getNotesUrl(workspaceId, id), payload);
}

export function updateNote(
  workspaceId: string,
  contactId: number,
  id: number,
  payload?: NoteRequest
): Promise<NotesResponse> {
  return http.put(getNoteUrl(workspaceId, contactId, id), payload);
}

export function deleteNote(
  workspaceId: string,
  contactId: number,
  id: number,
  payload?: NoteRequest
): Promise<NotesResponse> {
  return http.delete(getNoteUrl(workspaceId, contactId, id), payload);
}
